import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { RegistrationOwner, RegistrationStaff } from 'app/model/RegistrationRequest'; // ADD RegistrationStaff import
import { Suburb } from 'app/model/suburbs';
import { OperatorFunction, Observable } from 'rxjs';
import { debounceTime, distinctUntilChanged, map } from 'rxjs/operators';

@Component({
  selector: 'pharmacy-staff-ngbd-modal-content',
  templateUrl: './pharmacy-staff-modal.component.html',
  styleUrls: ['./pharmacy-staff-modal.component.scss']
})
export class PharmacyStaffNgbdModalContent implements OnInit {
  @Input() ro: RegistrationStaff; // CHANGE: Use RegistrationStaff instead of RegistrationOwner
  @Output() passEntry: EventEmitter<RegistrationStaff> = new EventEmitter<RegistrationStaff>(); // CHANGE: Use RegistrationStaff
  @Input() suburbs: Suburb[];

  constructor(public activeModal: NgbActiveModal) {
    this.ro = new RegistrationStaff(); // CHANGE: Use RegistrationStaff
  }

  ngOnInit(): void {
    if (!this.ro) {
      this.ro = new RegistrationStaff(); // CHANGE: Use RegistrationStaff
    }
  }

  search: OperatorFunction<string, readonly Suburb[]> = (text$: Observable<string>) =>
    text$.pipe(
      debounceTime(200),
      distinctUntilChanged(),
      map(term => term.length < 2 ? []
        : this.suburbs.filter(v => v.name.toLowerCase().indexOf(term.toLowerCase()) > -1).slice(0, 10))
    )

  formatter = (x: any) => x.name + ' - ' + x.state.name + ' - ' + x.postCode.name;


//   save() {
//     this.passEntry.emit(this.ro)
//     this.activeModal.close();
//   }

  copyAddressChange(): void {
    if (this.ro.pharmacyAddressCopy) {
      this.ro.postalAddressStreet1 = this.ro.pharmacyAddressStreet1;
      this.ro.postalAddressStreet2 = this.ro.pharmacyAddressStreet2;
      this.ro.postalSuburb = this.ro.pharmacySuburb;
      this.ro.postalState = this.ro.pharmacyState;
      this.ro.postalSuburbId = this.ro.pharmacySuburbId;
      this.ro.postalStateId = this.ro.pharmacyStateId;
      this.ro.postalPostCodeId = this.ro.pharmacyPostCodeId;
      this.ro.postalPostCode = this.ro.pharmacyPostCode;
    }
  };

  suburbChange = (suburb: Suburb) => {
    this.ro.pharmacyState = suburb.state.name;
    this.ro.pharmacyStateId = suburb.state.id;
    this.ro.pharmacyPostCode = suburb.postCode.name;
    this.ro.pharmacyPostCodeId = suburb.postCode.id;
    this.ro.pharmacySuburbId = suburb.id;
  }


  postalSuburbChange = (suburb: Suburb) => {
    this.ro.postalState = suburb.state.name;
    this.ro.postalStateId = suburb.state.id;
    this.ro.postalPostCode = suburb.postCode.name;
    this.ro.postalPostCodeId = suburb.postCode.id;
    this.ro.postalSuburbId = suburb.postCode.id;
  }

  save() {
    this.passEntry.emit(this.ro);
    this.activeModal.close();
  }
}